import { render, staticRenderFns } from "./BatchAssess.vue?vue&type=template&id=50a4bd27"
import script from "./BatchAssess.vue?vue&type=script&lang=js"
export * from "./BatchAssess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports